import { useState } from 'react';
import { api, setToken, type Session } from '../api.js';

/**
 * Login do painel interno, em /admin.
 *
 * Separado do login dos clientes por pedido do dono, e a separação é real: o
 * servidor recusa credencial de admin no formulário público e recusa credencial
 * de cliente aqui. Uma tela "de admin" que aceitasse os dois seria só enfeite.
 *
 * A aparência é deliberadamente sóbria e sem a marca comercial: quem chega aqui
 * por engano precisa perceber na primeira olhada que não é a porta dele — mas
 * sem que a página confirme que existe um painel interno neste endereço, o que
 * seria informação de graça para quem estivesse fuçando.
 */

export function AdminAuth({
  onAuthenticated,
  onSair,
}: {
  onAuthenticated: (session: Session) => void;
  onSair: () => void;
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setEntrando(true);
    setErro(null);
    try {
      const session = await api.adminLogin({ email: email.trim(), password });
      setToken(session.token);
      onAuthenticated(session);
    } catch (cause) {
      // A mensagem do servidor é genérica de propósito ("usuário ou senha
      // inválidos"), inclusive quando a credencial existe mas é da outra
      // porta — dizer "esse login é de cliente" revelaria quem é quem.
      setErro(cause instanceof Error ? cause.message : 'Não foi possível entrar');
    } finally {
      setEntrando(false);
    }
  }

  return (
    <div className="admin-gate">
      <form className="admin-gate-card" onSubmit={submit}>
        <p className="admin-gate-eyebrow mono">painel interno</p>
        <h1 className="admin-gate-title">Acesso restrito</h1>

        <label htmlFor="ag-user">Usuário</label>
        <input
          id="ag-user"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          autoFocus
          required
        />

        <label htmlFor="ag-pass">Senha</label>
        <input
          id="ag-pass"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />

        {erro && (
          <p className="notice err" style={{ margin: '10px 0 0', fontSize: 12.5 }}>
            {erro}
          </p>
        )}

        <button
          type="submit"
          className="primary"
          style={{ marginTop: 14, width: '100%' }}
          disabled={entrando}
        >
          {entrando ? <span className="spinner" /> : 'Entrar'}
        </button>

        <button
          type="button"
          className="ghost"
          style={{ marginTop: 10, width: '100%', fontSize: 12.5 }}
          onClick={onSair}
        >
          ← Ir para o site
        </button>
      </form>
    </div>
  );
}
